import React from 'react';

export default function OverlayContent(props) {
    return (
        <div className="c_23_2_1">
            {props.children}
        </div>
    );
}
